import React, { useEffect } from 'react';
import System from "../../helper/system";
import $ from "jquery";

let c = System.getParams();
const { storageName: { UNIVERSAL_SEARCH_PARAM } } = System

const NoDataFound = (props) => {
    useEffect(() => {
        async function fetchHere() {
            c.search = c.search ? c.search : localStorage.getItem(UNIVERSAL_SEARCH_PARAM);
            history.pushState(null, null, '?' + $.param(c));
            localStorage.setItem(UNIVERSAL_SEARCH_PARAM, '')
        }

        fetchHere()
    }, [])
    return (
        <>
            <div className="note container">
                <div className='text-start nosearchfound mb-4'>
                    <b> <i className="fa fa-info-circle text-black me-1" aria-hidden="true" /> No results found for &quot;{c.search ? c.search : localStorage.getItem(UNIVERSAL_SEARCH_PARAM)}&quot;. </b>
                    <a href={System.redirectToNewark(c.search ? c.search : localStorage.getItem(UNIVERSAL_SEARCH_PARAM))} className='text-blue-dark'></a>
                </div>
            </div>
        </>
    );
}

export default NoDataFound;
